<script>
    // Import general mixin for shared functionality.
    import mixin from './../mixin';

    import SourceSet from './SourceSet.vue';

    export default {
        mixins: [mixin],
        components: { SourceSet },
        props: {
            item: {
                type: Object,
                required: true
            },
            blockView: {
                type: Boolean,
                default: true
            }
        }
    };
</script>

<template>
    <a :href="item.url" class="course-item is-flex has-border-bottom has-border--dark">
        <div :class="['course-content', 'is-flex-grow-1', 'is-flex', blockView ? 'is-flex-direction-column' : '']">
            <div v-if="item.previewImageSet && item.previewImageSet.length" :class="['course-image', blockView ? 'mb-3' : '']">
                <source-set :image-sets="item.previewImageSet" image-class="image has-curve-left-right" />
                <span class="tags" v-if="item.categoriesWithColors && item.categoriesWithColors.length">
                    <span :class="['tag', 'has-text-weight-semibold', category.color]" v-for="(category, index) in item.categoriesWithColors" :key="'cat-' + index">{{ category.name }}</span>
                </span>
            </div>
            <div v-else class="course-image course-image--fallback has-curve-left-right mb-3">
                <span class="tags" v-if="item.categoriesWithColors && item.categoriesWithColors.length">
                    <span :class="['tag', 'has-text-weight-semibold', category.color]" v-for="(category, index) in item.categoriesWithColors" :key="'cat-' + index">{{ category.name }}</span>
                </span>
            </div>
            <div :class="['course-content-wrapper', blockView ? '' : 'ml-5']">
                <h4 v-if="item.name" class="title is-5">
                    {{ item.name }}
                </h4>
                <div v-if="item.intro" class="block content">
                    <p>{{ item.intro }}</p>
                </div>
                <p v-if="item.targetAudiences && item.targetAudiences.length" class="block is-size-11">
                    <i>{{ item.targetAudiences.join(', ') }}</i>
                </p>
                <div class="tags block" v-if="item.tags && item.tags.length">
                    <span v-for="(tag, index) in item.tags" :key="index" class="tag is-light has-text-weight-semibold">
                        {{ tag }}
                    </span>
                </div>
            </div>
        </div>
    </a>
</template>
